import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
export default class TaskStatus extends React.Component {
  localizedData = [
    { text: "Closed", value: true },
    { text: "Open", value: false },
  ];
  componentDidMount = () => {
    if (
      this.props.dataItem.inEdit &&
      document.getElementById("taskstatusId")
    ) {
      document.getElementById("taskstatusId").focus();
    }
  };
  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.value,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit 
    ) {
      let updateData = {
        ...this.props.dataItem,
        [this.props.field]: e.target.value.value,
      };
      this.props.updateDropdownValue(updateData);
    }
  };

  handleEditCell = () => {
    this.props.onEditCell(this.props.dataItem, this.props.field);
  };

  render() {
    const { dataItem, field } = this.props;
    const dataValue = dataItem[field];
    if (field && dataItem.inEdit === field) {
      return (
        <DropDownList
          style={{ width: "100px" }}
          onChange={this.handleChange}
          value={this.localizedData.find((c) => c.value === dataValue)}
          data={this.localizedData}
          textField="text"
          id="taskstatusId"
          // disabled={this.props.dataItem.isClosed === "Closed" ? true : false}
        />
      );
    }

    return this.props.dataItem.roleName == "Standard User" ||
      this.props.dataItem.roleName == "View Only"  ? (
      <td>
        {dataValue===true||dataValue==="Closed"? "Closed":"Open"}
      </td>
    ) : (
      <td onClick={this.handleEditCell}>
        {dataValue===true||dataValue==="Closed"? "Closed":"Open"}
      </td>
    );

  }
}
